export default __webpack_public_path__ + "static/media/Baleful Brand.244ca953.png";